module.exports = "/_next/static/images/simulated-attacks-and-penetration-testing-97abba7e375801a7639291bc5fac4353.webp";